import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'Manufactoring Name',
        dataIndex: 'name'
      },
      {
        title: 'Confirmed Shipment Date',
        dataIndex: 'confirmed_shipment_date'
      }
    ]
  }

  getData = manufacturings => {
    return manufacturings.map((item, index) => {
      item.confirmed_shipment_date = moment(new Date(item.confirmed_shipment_date)).format(
        'YYYY-MM-DD'
      )
      item.key = item.id
      return item
    })
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      jobList.push(
        <div>
          <h6 className="steps">{item.job_name}</h6>
          {item.manufacturings.length == 1 && (
            <p>
              Confirmed Shipment Date:{' '}
              {moment(new Date(item.manufacturings[0].confirmed_shipment_date)).format(
                'YYYY-MM-DD'
              )}
            </p>
          )}
          {item.manufacturings.length > 1 && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData(item.manufacturings)}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
        </div>
      )
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Jobs</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/confirmed-shipment-dates/ListItem.js